module.exports = __webpack_public_path__ + "static/team-b5d8963950604d45e000968485208a3e.jpg";